import { render } from "./AdvancedReportView.vue?vue&type=template&id=70c32e6a&scoped=true&ts=true"
import script from "./AdvancedReportView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdvancedReportView.vue?vue&type=script&setup=true&lang=ts"

import "./AdvancedReportView.vue?vue&type=style&index=0&id=70c32e6a&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c32e6a"],['__file',"resources/js/views/advanced-report/AdvancedReportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70c32e6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70c32e6a', __exports__)) {
    console.log('reload')
    api.reload('70c32e6a', __exports__)
  }
  
  module.hot.accept("./AdvancedReportView.vue?vue&type=template&id=70c32e6a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('70c32e6a', render)
  })

}


export default __exports__